import { render, staticRenderFns } from "./ProductPromoSelector.vue?vue&type=template&id=e3c9131a"
import script from "./ProductPromoSelector.vue?vue&type=script&lang=js"
export * from "./ProductPromoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports